<script>
    import {link} from 'svelte-spa-router'
    export let list

</script>

<div class="fv-hero">
    <ul>
        {#each list as item}
            <li><span>{item.date}</span><a href={`/news/${item.id}`} use:link>{item.title}</a></li>
        {/each}
    </ul>
</div>
<style>
    ul{
        padding: 0;
        margin: 0;
    }
    li{
        list-style: none;
        padding: 0;
        margin: 0;
        min-height: 56px;
        width: 1004px;
        border-bottom: 1px solid #707070;
        display: flex;
        align-items: center;
    }
    span{
        font-family: "Noto Sans JP", sans-serif;
        
        font-size: 16px;
        text-align: left;
        color: #000;
    }
    a{
        text-decoration: none;
        margin-left: 36px;
        font-family: "Noto Sans JP", sans-serif;
        
        font-size: 16px;
        text-align: left;
        color: #000;
        text-decoration: none;
        transition: opacity .5s;
    }
    a:after{
        margin-left: 52px;
        content:"→"
    }
    a:hover{
        opacity: 0.5;
        transition: opacity .5s;
    }
    @media screen and (max-width:640px){
        li{
            align-items: start;
            width: 100%;
            flex-direction: column;
            padding:20px 0;
            line-height: 36px;
        }
        a{
            margin-left: 0;
        }
        a::after{
            margin-left: 32px;
        }
        ul{
            margin: 0%;
            border-top:1px solid #707070;
        }
    }
</style>